// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3z-fe","header":"ReportDetails_header__2W9-S","title":"ReportDetails_title__9au0r","left":"ReportDetails_left__2HLTo"};